import { render, staticRenderFns } from "./checkout_header.vue?vue&type=template&id=953a8a52"
import script from "./checkout_header.vue?vue&type=script&lang=js"
export * from "./checkout_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "checkout_header.vue"
export default component.exports